import type { AllianceSunView, Fleet, PlanetShips, PlayerRace, SunAttackAlert } from '@kaeliux/shared';
import { authedPost } from './http';
import { normalizeFleet } from './fleet.service';
import { normalizeAllianceSun, normalizeSunAttackAlert } from './sunControlNormalization';

/**
 * Sun control — the attack notifications on the Fleets page, the alliance's
 * Suns tab and the garrison recall. Cloud Function POSTs: Suns are
 * server-only in `firestore.rules`, and every view is shaped per viewer
 * (concealment, the alliance's own garrisons). Mock mode swaps this file for
 * `services/mock/sun.service.ts`.
 */

/** Inbound Sun attacks this player is told about — see `buildSunAttackAlerts`. */
export async function getSunAlerts(): Promise<SunAttackAlert[]> {
    const data = await authedPost<{ alerts: unknown[] }>('/getSunAlerts', {});
    return data.alerts.map(normalizeSunAttackAlert);
}

/** Every Sun the caller's alliance has claimed or controls. */
export async function getAllianceSuns(): Promise<AllianceSunView[]> {
    const data = await authedPost<{ suns: unknown[] }>('/getAllianceSuns', {});
    return data.suns.map(normalizeAllianceSun);
}

export interface RecallSunGarrisonInput {
    galaxy: number;
    system: number;
    race: PlayerRace;
    ships: PlanetShips;
}

/** Bring part of a controlled Sun's garrison home — leader only, never below the floor. */
export async function recallSunGarrison(input: RecallSunGarrisonInput): Promise<Fleet> {
    const data = await authedPost<{ fleet: unknown }>('/recallSunGarrison', input);
    return normalizeFleet(data.fleet);
}
